<div class="container AdWritter" *ngIf="view == 0">
  <div class="row">
    <div class="col-12">
      <h1 class="mt-2">Let one of our professionals write Your ad for You</h1>
    </div>
    <div class="col-12 text-center">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
<div class="container AdWritter" *ngIf="view > 0">
  <div class="row" *ngIf="view == 1 || view == 2">
    <div class="col-12 animated fadeInTop">
      <h1 class="mt-2">Let one of our professionals write your ad for You</h1>
    </div>
    <div class="col-12">
      <div class="d-flex">
        <div><img src="/images/person1.jpg" alt="Help" style="float: left; height: 128px;" class="m-2"></div>
        <div style="display: flex; align-items: center; font-size: 18px; text-align: justify">We all know that writing about ourselves could be a challenging task as we are not sure what others would find appealing, and what would be considered as a turnoff. We are here to make things easier for you to ensure that your Wickedlist experience is not only pleasant but unforgettable.</div>
      </div>
    </div>
    <div class="col-12">
      <div class="d-flex">
        <div style="display: flex; align-items: center; font-size: 18px; text-align: justify">
          Fill out the following form to provide basic information about yourself and what you are looking for. (Fill out ONLY as much you want to share with others) Once you send this to us, one of our team members will write an ad for you and send it back through the email you provide. Please note that we won’t write casual dating ads so make sure that you want us to write ONLY the long-term relationship ad.
        </div>
        <div><img src="/images/person2.jpg" alt="Help" style="float: left; height: 128px;" class="m-2"></div>
      </div>
    </div>
  </div>
  <div *ngIf="view == 1" class="animated fadeIn">
    <div>
      <div class="row">
        <div class="col-12"><strong>Your basic info:</strong></div>
      </div>
      <form [formGroup]="dataForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Name / nickname</mat-label>
              <input formControlName="name" matInput>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Gender</mat-label>
              <mat-select formControlName="gender">
                <mat-option *ngFor="let g of gender" [value]="g">
                  {{g}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Race</mat-label>
              <mat-select formControlName="race">
                <mat-option *ngFor="let r of race" [value]="r">{{r}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>I'm looking for</mat-label>
              <mat-select formControlName="lookingFor">
                <mat-option *ngFor="let g of gender" [value]="g">
                  {{g}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Age</mat-label>
              <input formControlName="age" matInput>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Height</mat-label>
              <input formControlName="height" matInput>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Weight</mat-label>
              <input formControlName="weight" matInput>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Body Type</mat-label>
              <mat-select formControlName="bodyType">
                <mat-option [value]="'Average'">Average</mat-option>
                <mat-option [value]="'Athletic / fit'">Athletic / fit</mat-option>
                <mat-option [value]="'Few extra pounds / chubby'">Few extra pounds / chubby</mat-option>
                <mat-option [value]="'Muscular'">Muscular</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>My ideal match would be</mat-label>
              <textarea formControlName="idealMatch" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>What are you looking for in a relationship?</mat-label>
              <textarea formControlName="lookingForRelationship" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>What’s your favorite thing to do during free time?</mat-label>
              <textarea formControlName="thingsInFreeTime" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>Important things/aspects of life for you</mat-label>
              <textarea formControlName="aspectsOfLife" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>Things you don’t like</mat-label>
              <textarea formControlName="dontLike" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>Your passion / interest</mat-label>
              <textarea formControlName="passions" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>Your occupation</mat-label>
              <textarea formControlName="occupation" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>What’s your 4 characteristics that are dominating in your personality?</mat-label>
              <textarea formControlName="characteristics" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>Your goals and dreams</mat-label>
              <textarea formControlName="goalsAndDreams" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>I’m thankful the most for</mat-label>
              <textarea formControlName="thankfullFor" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>Do you have kids / want kids?</mat-label>
              <textarea formControlName="kids" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100">
              <mat-label>Your education</mat-label>
              <textarea formControlName="education" matInput rows="6"></textarea>
            </mat-form-field>
          </div>
          <div class="col-12 mb-3">
            <strong>Your lifestyle:</strong>
          </div>
          <div class="col-4 mb-3">
            <label>Do you work out?</label>
            <div>
              <mat-radio-group formControlName="workout">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4 mb-3">
            <label>Do you travel?</label>
            <div>
              <mat-radio-group formControlName="travel">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4">
            <label>Do you eat healthy food?</label>
            <div>
              <mat-radio-group formControlName="healthyFood">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4">
            <label>Do you smoke?</label>
            <div>
              <mat-radio-group formControlName="smoke">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4">
            <label>Do you drink alcohol?</label>
            <div>
              <mat-radio-group formControlName="alcohol">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-12 mt-3">
            <mat-form-field class="w-100">
              <mat-label style="color: #f44336"><strong>Your email</strong> (we will send your ad to this email)</mat-label>
              <input formControlName="email" matInput required>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-checkbox required="true" formControlName="termsAndConditions">
              By checking this box you agree upon our terms that we will write the ad for you using up to 200 words. You won’t have any revision after receiving your written ad. We might not use all the provided info in the form. You have no guarantee that this ad will help you find a partner. Also, we do not offer any refund if for some reason you are not satisfied. It might take up to 24-48 hours to send your ad- depending upon traffic
            </mat-checkbox>
          </div>
          <div class="col-4 pl-0">
            <premium-ad-token-payment #addTokenPayment [paymentFormType]="1" (onTokenAdded)="onTokenAdded($event)"></premium-ad-token-payment>
          </div>
          <div class="col-12"></div>
          <div class="col-4 mt-2">
            <button class="create-button w-100 p-2" color="primary" mat-flat-button type="submit" [disabled]="blockSubmit" >
              <mat-spinner color="primary" diameter="30" *ngIf="loading"></mat-spinner><span *ngIf="!loading">Pay $9.99 & Submit</span>
            </button>
          </div>
        </div>
      </form>
    </div>

  </div>
  <div *ngIf="view == 3">
    <div class="row">
      <div class="col-12">
        <h1 class="mt-4">Thank You for posting data!</h1>
      </div>
      <div class="col-12 mb-3">
        We will contact You with your new brilliant advertisement!
      </div>
      <div class="col-12">
        <a mat-flat-button color="accent" routerLink="/">Go to main page</a>
      </div>
    </div>
  </div>


</div>
